export default __webpack_public_path__ + "static/media/lyncspot.172b0078.png";